export default {
      id: "ic_play_failure-usage",
      viewBox: "0 0 38 38",
      url: "/" + "images/icons.3.109.2.svg#ic_play_failure-usage",
      toString: function () {
        return this.url;
      }
    }